var map = {
	"./images/cards_logos/amex.svg": "L0L7",
	"./images/category_image_placeholder.svg": "TLSL",
	"./images/confinus-avatar-black.png": "f75i",
	"./images/confinus-avatar.png": "d1t7",
	"./images/confinus-logo.png": "Q5fj",
	"./images/confinus_logo.png": "RO2F",
	"./images/iconmonstr-candy-6.svg": "yESg",
	"./images/shield.svg": "PaNi",
	"./images/shopping/brand.svg": "BkNQ",
	"./images/shopping/delivery.svg": "yWLZ",
	"./images/shopping/flag.svg": "KJTo",
	"./images/shopping/frozen.svg": "9HR0",
	"./images/shopping/grade.svg": "/a2f",
	"./images/shopping/question-mark.svg": "yyIK",
	"./images/shopping/tag.svg": "r+Qm",
	"./images/sparkles.svg": "BawQ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GeFs";